var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"ma-0 pa-0"},_vm._l((_vm.values),function(v){return _c('img',{key:v.id,staticClass:"ma-0 pa-0",attrs:{"width":"32px;","height":"32px;","src":v.path}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }